import DonationBannerIframeHandler from './donation-banner-iframe-handler.js';

/* eslint semi: 0, no-undef: 0 */
const ESC_KEYCODE = 27;
const event_namespace = 'RemindForm';

class RemindForm {
  constructor($form, $trigger, cookieFN) {
    this.$form = $form;
    this.$trigger = $trigger;
    this.setDonationCookie = cookieFN || $.noop;
  }

  /**
   * checks if email is valid
   * @param {String} email
   * @return {Bool}
   */
  static validateDonorEmail(email) {
    return /.+@.+\..+/.test(email);
  }

  /**
   * checks if name field is valid
   * @param {String} email
   * @return {Bool}
   */
  static validateNameField(name) {
    return !/[<>&:?'"]/.test(name);
  }

  setup() {
    const $dropdown = $('#donate_dropdown');
    const $close_trigger = $('#close_donate_dropdown');
    const baseUrl = this.$form.attr('data-base-url') || 'https://archive.org';

    this.$trigger.on(`click.${event_namespace}`, (event) => {
      if (!$dropdown.hasClass('is-open'))
        $dropdown.addClass('is-open');

      this.$form.find('input').filter((i, el) => !el.value).eq(0).focus();

      DonationBannerIframeHandler.openReminderForm();
      event.preventDefault();
    });

    $close_trigger.on(`click.${event_namespace}`, () => {
      $dropdown.removeClass('is-open');
      DonationBannerIframeHandler.closeReminderForm();
      this.$trigger.focus();
    });

    $(window).on(`keydown.${event_namespace}`, (e) => {
      const formIsOpen = $dropdown.hasClass('is-open');
      if (formIsOpen && (e.keyCode === ESC_KEYCODE)) {
        $close_trigger.click();
      }
    });

    this.$form.on(`submit.${event_namespace}`, (e) => {
      e.preventDefault();

      if (!RemindForm.validateDonorEmail(this.$form.find('[name=email]').val())) {
        this.$form.find('.error-email').show();
        return;
      }

      ['first_name', 'last_name'].forEach((field) => {
        if (!RemindForm.validateNameField(this.$form.find(`[name='${field}']`).val())) {
          this.$form.find(`[name='${field}']`).val('');
        }
      });

      const sourceContext = this.$trigger.attr('data-source-context') || '';
      if (typeof archive_analytics !== 'undefined') {
        archive_analytics.send_event_no_sampling(
          `DonateBanner${sourceContext}`,
          'MaybeLaterFormSubmit',
          window.location.pathname,
        );
      }

      this.sendForm(baseUrl);
    });
  }

  sendForm(baseUrl) {
    const $success_message = $('#donate_reminder_success').addClass('hidden');
    const messageTmpl = (heading, copy) => (
      `<h2>${heading}</h2><p>${copy}</p>`
    );

    $.ajax({
      type: 'post',
      url: `${baseUrl}/donate/remindDonate.php`,
      data: this.$form.serialize(),
      success: () => {
        this.$form.addClass('hidden');
        $success_message.html(messageTmpl('Thank You!', "We'll be in touch in the next few days with a reminder to donate to the Internet Archive."))
          .removeClass('hidden');
        const daysBannerIsHidden = 90;
        this.setDonationCookie(daysBannerIsHidden);
        DonationBannerIframeHandler.onSubmitReminderForm(daysBannerIsHidden);
      },
      error: () => {
        $success_message.html(messageTmpl('Hmmm...', 'Something is amiss. Can you try again in a little while?'))
          .removeClass('hidden');
      },
    });
  }
}

export { RemindForm as default };
